

import React, {Component, useEffect, useState} from 'react';
import  Loct_common from '../Component/Loct_common.js';
import '../../CompanyInfo/css/Location.css';
import building1 from '../img/사업장1.png';
import building2 from '../img/사업장2.png';
import building3 from '../img/사업장3.png';
import Text from '../../../common/Text.js';



const AdressInfo1 = {
    companyNm : '거제 본사',
    adress : '경상남도 거제시 장평3로 75 (장평동) 설계지원센터 2관',
    number : '055-630-8168',
    fex : '055-630-8168',
    // gugdo : '36.39200936301132',
    // weedo : '127.4023688431917'
    gungdo : '34.894457086572395',
    weedo : '128.60656335950185',
    mapid : 'map1',
    imgsrc : building1
    
  }
  
  
  const AdressInfo3 = {
    companyNm : '대전 대덕 연구소',
    adress : '대전광역시 유성구 문지동 103-6 삼성중공업대덕연구센터',
    number : '042-865-4745',
    fex : '314-85-29960',
    gungdo : '36.39200936301132',
    weedo : '127.4023688431917',
    mapid : 'map3',
    imgsrc : building3
  }






  function LOC()
 {
      
const [remainingHeight, setRemainingHeight] = useState(0);
const [Display, setDisplay] = useState('none');


      const handleHover = (height) => {
        setRemainingHeight(height);
        console.log('Received Remaining height:', height);
        setDisplay('block');
        console.log('Received Remaining height:', Display);
      
      };
      const handleHoverEnd = () => {
        console.log('Hover ended in MainComponent');
        setDisplay('none');
      };
      
      return (

        
    <div>
{/* 
<header>
<Header onHover={handleHover} onHoverEnd={handleHoverEnd}/>
            <div style={{ zIndex:2, display:Display,position: 'fixed', bottom: 0, left: 0, right: 0, height:remainingHeight, backgroundColor:'black', width:'100%', opacity:0.6}}/> 

        </header> */}

        <div className = 'groups'>
          
         <Text variant="titlename" >
                    <div className="Titles">찾아 오시는 길</div>
         </Text>
        <div className = 'firstL'>
        <Loct_common 
          companyNm={AdressInfo1.companyNm}
          adress={AdressInfo1.adress}
          number={AdressInfo1.number}
          fex={AdressInfo1.fex}
          gungdo={AdressInfo1.gungdo}
          weedo={AdressInfo1.weedo}
          mapid={AdressInfo1.mapid}
          imgsrc={AdressInfo1.imgsrc}
          imgId = 'img1'
        ></Loct_common>
        {/* <Map map={AdressInfo1.map} gungdo={AdressInfo1.gungdo} weedo={AdressInfo1.weedo} /> */}
        <div className='squere'> </div>

        <Loct_common
          companyNm={AdressInfo3.companyNm}
          adress={AdressInfo3.adress}
          number={AdressInfo3.number}
          fex={AdressInfo3.fex}
          gungdo={AdressInfo3.gungdo}
          weedo={AdressInfo3.weedo}
          mapid={AdressInfo3.mapid}
          imgsrc={AdressInfo3.imgsrc}
          imgId = 'img3'
        ></Loct_common>
        {/* <Map map={AdressInfo3.map} gungdo={AdressInfo3.gungdo} weedo={AdressInfo3.weedo} /> */}
           </div>     </div>
          {/* <img src={Foot} style={{width : 1680, top : 300}}></img> */}
           </div>
           
     );}
   export default LOC;